import React from 'react';
import Tour from '../Tour/Tour';
import useTours from '../../../hooks/useTours';

const Tours = () => {
    const [tours] = useTours();

    return (
        <div className="py-24 bg-white mt-16">
            <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-10">
                <div className="text-center mb-20">
                    <h3 className="text-4xl md:text-5xl font-black text-slate-900 tracking-tight lowercase">explore our top <span className="text-amber-500">tour plans</span></h3>
                    <div className="w-24 h-2 bg-amber-500 mx-auto mt-6 rounded-full shadow-lg shadow-amber-500/20"></div>
                </div>
                
                {tours.length === 0 ? (
                    <div className="flex flex-col justify-center items-center h-64">
                        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-amber-500 mb-4"></div>
                        <p className="font-bold tracking-widest uppercase text-xs text-slate-400">Finding adventures...</p>
                    </div>
                ) : (
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
                        {tours.map(tour => <Tour key={tour._id} tour={tour}></Tour>)}
                    </div>
                )}
            </div>
        </div>
    );
};

export default Tours;